import * as React from 'react';

import {Card} from '../card/card';
import {colors} from '../colors/colors';
import type {ColorName} from '../colors/colors';

type Props = {
    cardHeight?: number;
    cardWidth?: number;
    numCards: number;
    cardBackgroundColor?: ColorName;
    flexProps?: {
        gap: number;
    };
};

export function GridListLoadingCards(props: Props) {
    const {
        cardHeight = 175,
        cardWidth,
        numCards,
        cardBackgroundColor = 'offWhite',
        flexProps,
    } = props;

    const cards = [...Array(numCards)].map((_, index) => (
        <Card
            key={`placeholder-${index}`}
            hasBorder={true}
            fitHeight={true}
            backgroundColor={cardBackgroundColor}
            borderColor={colors.offWhite}
            hasShadow={false}
        >
            <div style={{height: cardHeight, width: cardWidth}} />
        </Card>
    ));

    return flexProps ? (
        <div className={flexProps ? `flex gap-${flexProps.gap}` : ''}>{cards}</div>
    ) : (
        <>{cards}</>
    );
}
